<div class="income-statement-compare">
  <klt-section
    title="Income statement"
    type="button"
    buttonText="COMPARE"
    (buttonClick)="handleClick()"
  >
  </klt-section>
</div>
